<app-unsaved-form-check
  [unsavedFormCheckService]="unsavedFormCheckService"
></app-unsaved-form-check>
<div class="modal-header">
  <div class="d-flex align-items-center">
    <div class="sender-profile d-flex justify-content-center mr-3">
      <div class="message-to-profile rounded-circle">
        <img
          alt="profile image"
          [src]="profileImage"
          appDefaultAvatar
          appDynamicImgUrl
        />
      </div>
    </div>
    <div>
      <h3 class="modal-title" translate>
        {{ postData | call : getModalTitle }}
      </h3>

      <span class="text-gray-500"
        ><i class="fas fa-globe-europe mr-2"></i>
        <span
          *ngIf="currentOrg; else everybodyPost"
          [innerHtml]="
            'UI.ViewPost.InnovationSpace'
              | translate
              | stringReplacement
                : {
                    '{organizationName}': orgName?.outerHTML
                  }
          "
        >
          <span #orgName class="text-medium-gray font-weight-bold">{{
            currentOrg?.name
          }}</span>
        </span>
        <ng-template #everybodyPost>
          <span translate>UI.ViewPost.Everybody</span>
        </ng-template>
      </span>
    </div>
  </div>
  <button
    type="button"
    class="btn-close close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="new-message-dialog-modal-body post-dialog-body">
  <ng-container
    *ngIf="isLoadingAttributeDescriptions$ | async; else sendMessageTemplate"
  >
    <div class="d-flex justify-content-center align-items-center px-4 py-3">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </ng-container>
  <ng-template #sendMessageTemplate>
    <form [formGroup]="form">
      <!--  Editor for content -->
      <div class="d-flex flex-row px-4 py-3 bg-white-smoke">
        <div class="message-content-quill ml-0">
          <div class="d-flex align-items-center pb-2 bg-white-smoke">
            <div
              *ngIf="isCreationMode(postData) && !disableTinyMCE"
              class="d-flex align-items-center"
            >
              <div class="radio mr-0">
                <input
                  name="editorType"
                  formControlName="editorType"
                  id="jip-editor"
                  type="radio"
                  class="mr-1"
                  [value]="EditorType.SIMPLE"
                  [checked]="editorTypeControl?.value === EditorType.SIMPLE"
                  (click)="onRadioChange($event, EditorType.SIMPLE)"
                />
                <label for="jip-editor" class="radio-info mr-4 radio-label">
                  <span class="radio-text" translate
                    >UI.Editor.StandardEditor</span
                  >
                </label>
              </div>

              <div class="radio">
                <input
                  name="editorType"
                  formControlName="editorType"
                  id="tiny-editor"
                  type="radio"
                  class="mr-1"
                  [value]="EditorType.ADVANCE"
                  [checked]="editorTypeControl?.value === EditorType.ADVANCE"
                  (click)="onRadioChange($event, EditorType.ADVANCE)"
                />
                <label for="tiny-editor" class="radio-info radio-label">
                  <span class="radio-text" translate
                    >UI.Editor.AdvancedEditor</span
                  >
                  (
                  <i class="jip-fa jip-fa--beta"></i>
                  <span class="" translate> UI.Editor.BetaVersion </span>
                  )
                </label>
              </div>
            </div>
            <div class="d-flex align-self-end ml-auto">
              <app-boostrap-dropdown
                [items]="[
                  {
                    value: ('UI.News.Public' | translate),
                    codeId: true,
                    img: '/wp-content/themes/jip/assets/images/icons/glope.png'
                  },
                  {
                    value: ('UI.News.RegisteredUsersOnly' | translate),
                    codeId: false,
                    img: '/wp-content/themes/jip/assets/images/icons/registered-user.png'
                  }
                ]"
                [currentIndex]="form.get('isPublic').value === true ? 0 : 1"
                (selectItem)="onIsPublicSelect($event)"
                [styleClass]="'custom-dropdown icon-dropdown-xs dropdown-bg--none'"
                [dropdownImgClass]="'icon-dropdown-xs'"
              ></app-boostrap-dropdown>
            </div>
          </div>
          <app-form-field-custom
            #messageForm
            [hidden]="isAdvanceMode(postData)"
            [formInput]="form"
            [type]="AttributeType.RTE"
            [attributeDescription]="contentAttributeDescription"
            [shouldValidateOnTouch]="true"
            [options]="{
              placeholder: placeholder | translate,
              allowEmojiOnRTE: true,
              allowImgOnRTE: true,
              allowCropImg: true,
              aspectRatio: 16 / 9
            }"
            (ngxVisibility)="formFieldLoaded(messageForm)"
          >
          </app-form-field-custom>

          <app-rich-editor
            [hidden]="!isAdvanceMode(postData)"
            [formInput]="form"
            [type]="AttributeType.RTE"
            [controlName]="'Content'"
            [attributeDescription]="contentAttributeDescription"
            [shouldValidateOnTouch]="true"
            [options]="{
              placeholder: placeholder | translate,
              allowEmojiOnRTE: true,
              allowImgOnRTE: true,
              allowCropImg: true,
              aspectRatio: 16 / 9
            }"
          >
          </app-rich-editor>
        </div>

        <div class="mt-2"></div>
      </div>

      <!-- Category Select -->
      <div *ngIf="sessionService?.tenant?.tenantCategories" class="px-4">
        <div class="mt-3 mb-1 text-medium-gray font-size-sm">
          <span class="pointer-cursor" (click)="categoryCollapse.toggle()">
            <i
              class="fas"
              [class.fa-caret-up]="!isCategoryCollasped"
              [class.fa-caret-down]="isCategoryCollasped"
            ></i>
            {{ 'UI.Categories.Categories' | translate }}
          </span>
        </div>
        <div
          #categoryCollapse="ngbCollapse"
          [(ngbCollapse)]="isCategoryCollasped"
        >
          <app-categories-filter
            [orgId]="currentOrg?.id"
            [showLabel]="true"
            [showFilterBtn]="false"
            [multiple]="true"
            [postData]="postData"
            [appendTo]="'.post-dialog-body'"
            [wrapperClass]="'post-category-wrapper'"
            (valueChanges)="onCategoryChange($event)"
          ></app-categories-filter>
        </div>
      </div>

      <!-- Stream Select -->
      <div *ngIf="streams.length" class="px-4">
        <div class="mt-3 mb-1 text-medium-gray font-size-sm">
          <span
            class="pointer-cursor"
            (click)="advancedSettingCollapse.toggle()"
          >
            <i
              class="fas"
              [class.fa-caret-up]="!isAdvancedSettingCollasped"
              [class.fa-caret-down]="isAdvancedSettingCollasped"
            ></i>
            Advanced settings
          </span>
        </div>

        <div
          #advancedSettingCollapse="ngbCollapse"
          [(ngbCollapse)]="isAdvancedSettingCollasped"
        >
          <ng-container
            *ngIf="!(isLoadingStreamOptions$ | async) && streams.length"
          >
            <div class="d-flex align-items-center">
              <label
                class="pointer-cursor font-weight-bold filter-label"
                translate
                [for]="streams"
              >
                UI.PublishingStreams.Label
              </label>

              <div
                class="ml-2 d-flex align-items-center"
                triggers="click"
                [placement]="'right'"
                [ngbTooltip]="
                  'UI.PublishingStreams.ExplanationText' | translate
                "
                tooltipClass="page-header-tooltip"
                appTooltip
                #t="ngbTooltip"
                [toolTipControl]="t"
                tooltipClass="stream-tooltip"
              >
                <i
                  class="tooltip-icon fas fa-info-circle align-middle pointer-cursor font-size-md"
                ></i>
              </div>
            </div>
            <div class="mt-1 stream-select-wrapper">
              <ng-select
                *ngIf="!(isLoadingStreamOptions$ | async)"
                [placeholder]="'UI.SmallFilter.Select' | translate"
                [items]="streams"
                [multiple]="true"
                bindLabel="name"
                bindValue="id"
                [selectableGroup]="true"
                [closeOnSelect]="false"
                formControlName="streams"
              >
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-item$="item$"
                  let-index="index"
                >
                  <input
                    class="option-checkbox"
                    id="item-{{ index }}"
                    type="checkbox"
                    [checked]="item$.selected"
                  />
                  {{ index === 0 ? '' : index + '. ' }}{{ item.name }}
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                  {{ item.name }}{{ shouldShowComma(item) ? ', ' : '' }}
                </ng-template>
              </ng-select>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </ng-template>
</div>
<div class="modal-footer message-command">
  <button type="button" class="btn btn-outline-secondary" (click)="close()">
    {{ 'Cancel' | translate | uppercase }}
  </button>
  <button
    appRequireLogin
    [disabled]="
      form.invalid || isSubmitting || messageForm?.imageInputDisplay?.uploading
    "
    type="button"
    ngbAutofocus
    class="btn btn-primary"
    (click)="onSubmit(postData)"
  >
    <ng-container *ngIf="isSubmitting">
      <i class="fas fa-spinner fa-spin btn-icon-right"></i>
    </ng-container>
    <span>{{
      postData | call : getSubmitButtonText | translate | uppercase
    }}</span>
  </button>
</div>
